import React, { useEffect, useRef, useSyncExternalStore } from "react";
import ConfirmationModal from "./ConfirmationModal.jsx";
import { getGrainDialogSnapshot, registerGrainDialogHost, settleGrainDialog, subscribeGrainDialog } from "../utils/grainDialogs.js";

export default function GrainDialogHost() {
  const container = useRef(null);
  const request = useSyncExternalStore(subscribeGrainDialog, getGrainDialogSnapshot, () => null);
  useEffect(registerGrainDialogHost, []);
  useEffect(() => {
    const dialog = container.current;
    if (request && !dialog.open) dialog.showModal();
    else if (!request && dialog.open) dialog.close();
  }, [request]);
  useEffect(() => () => container.current?.close(), []);
  const isAlert = request?.kind === "alert";
  const finish = accepted => { if (request) settleGrainDialog(request.id, accepted); };
  return <dialog ref={container} aria-label="Fenêtre Grain" data-grain-dialog-container
    style={{ position: "fixed", inset: 0, width: "100vw", height: "100dvh", maxWidth: "none", maxHeight: "none", margin: 0, padding: 0, border: 0, background: "transparent" }}
    onCancel={event => { event.preventDefault(); finish(false); }}>
    {request ? <ConfirmationModal key={request.id} foreground portalContainer={container.current}
      title={isAlert ? "Action interrompue" : "Confirmer cette action ?"}
      description={request.description} tone={isAlert ? "danger" : "warning"}
      confirmLabel={isAlert ? "OK" : "Confirmer"} cancelLabel={isAlert ? null : "Annuler"}
      {...request.options} onConfirm={() => finish(true)} onCancel={() => finish(false)}
      onDismiss={() => finish(false)} onClose={() => finish(false)} /> : null}
  </dialog>;
}
